import classNames from 'classnames';
import React, { HTMLAttributes } from 'react';

import { RichMediaValue } from '@/interface/media';
import { getMediaUrlValue } from '@/material/form-upload/change-data';

import styles from './index.module.less';

export interface CoverProps extends HTMLAttributes<HTMLDivElement> {
  src?: RichMediaValue;
  width?: number;
  height?: number;
  borderRadius?: string;
  outerClassName?: string;
  innerClassName?: string;
  hasInner?: boolean;
}

/**
 * 普通封面背景图
 */
const Cover: React.FC<CoverProps> = ({
  src,
  width = 158,
  height = 90,
  borderRadius = 0,
  hasInner = true,
  className,
  outerClassName,
  innerClassName,
  children,
  onClick,
}) => {
  const url = getMediaUrlValue(src);
  return (
    <div
      className={classNames(styles.cover, className)}
      style={{ width, height, borderRadius }}
      onClick={onClick}
    >
      <div
        className={classNames(outerClassName, styles.outer, { [styles.none]: !url })}
        style={{
          backgroundImage: `url(${url || '//nova.file.video.qpic.cn/uploadFile/a11.png'})`,
        }}
      ></div>
      {hasInner ? (
        <div className={classNames(innerClassName, styles.inner)}>
          {url ? <img src={url} alt='' width='auto' height={height} /> : null}
        </div>
      ) : null}
      {children}
    </div>
  );
};

export default Cover;
